import React from 'react';
import PropTypes from 'prop-types';

/**
 * Wrapper that renders a progress bar with the accessible name on the
 * [role=progressbar] element itself, satisfying axe aria-progressbar-name.
 *
 * React Bootstrap 2.x ProgressBar places aria-label on the outer .progress
 * wrapper div rather than on the inner [role=progressbar] element, which
 * causes axe aria-progressbar-name violations. This component renders the
 * same Bootstrap progress markup directly so aria-label lands on the right
 * element without any axe rule exclusions.
 */
export default function AccessibleProgressBar({
    now,
    max = 100,
    label,
    variant,
    className,
}) {
    const pct = max > 0 ? Math.min(Math.max((now / max) * 100, 0), 100) : 0;
    const variantClass = variant ? ` bg-${variant}` : '';
    const outerClass = ['progress', className].filter(Boolean).join(' ');

    return (
        <div className={outerClass}>
            <div
                role="progressbar"
                aria-valuenow={Math.round(pct)}
                aria-valuemin={0}
                aria-valuemax={100}
                aria-label={label}
                className={`progress-bar${variantClass}`}
                style={{ width: `${pct}%` }}
            />
        </div>
    );
}

AccessibleProgressBar.propTypes = {
    now: PropTypes.number.isRequired,
    max: PropTypes.number,
    label: PropTypes.string.isRequired,
    variant: PropTypes.string,
    className: PropTypes.string,
};
